module.exports = require("vue-virtual-scroll-list");